/**
 * Module entry point for Rudderstack sub modules
 * This module will orchestrate the sub modules
 *
 */

import 'vite/modulepreload-polyfill';

import * as RudderstackPageLoad from '~/lib/rudderstack/rudderstack-page-load';
import * as RudderstackQueryStringAPI from '~/lib/rudderstack/rudderstack-query-string-api';
import * as RudderstackReady from '~/lib/rudderstack/rudderstack-ready-api';
import * as RudderstackSDK from '~/lib/rudderstack/rudderstack-sdk';

// Initialize Rudderstack SDK with inferred shopify store App Key
RudderstackSDK.load();

// Configure rudderstack related logic to page load event
RudderstackPageLoad.onPageLoad();

// Configure Rudderstack Query String API (This should be replaced if Rudderstack team patch the SDK)
RudderstackQueryStringAPI.executeQueryStringApi();

// Configure 'RSA_Ready' event to replace 'window.rudderanalytics.ready'
RudderstackReady.onReadyEventInit();
